/** @jsxImportSource @emotion/react */

import { useNavigate } from "react-router-dom";
import UI from "@mile-meeting/mile-ui";
import { AgreeContainer, Container, FormSection, InputForm, SpanEssential } from "./index.styles";
import { css } from "@emotion/react";
import { useState } from "react";
import { registerUserWithGoogle } from "apis/auth/sign-up";
import { encrypt } from "utils/crypto";
import { acceptInviteMember } from "apis/member-invites/member-invites";
import { useToast } from "hook/useToast";

const GoogleSignup = ({ code, email, accessToken }: { code: string | null; email: string; accessToken: string }) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [name, setName] = useState<string>();
  const [acceptTerm, setAcceptTerm] = useState<boolean>(false);
  const [acceptPrivacy, setAcceptPrivacy] = useState<boolean>(false);

  const availableBtn = () => {
    if (email && name && acceptPrivacy && acceptTerm) return true;
    else return false;
  };

  const onHandleSignup = async () => {
    if (email && name && acceptPrivacy && acceptTerm) {
      const res = await registerUserWithGoogle(email, name, acceptPrivacy, acceptTerm, accessToken);
      if (res.success && res.accessToken) {
        if (code) {
          await acceptInviteMember(code);
        }
        localStorage.setItem("access-token", encrypt(res.accessToken));
        navigate("/workspace/list", { state: { signupSuccess: true } });
      } else {
        showToast("이미 가입된 이메일입니다.", "error");
      }
    }
  };

  return (
    <Container>
      <UI.Typography type="title01" fontStyle="bold" color="var(--alias-color-label-normal)">
        회원가입
      </UI.Typography>
      <InputForm>
        <FormSection>
          <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
            이메일
            <SpanEssential>*</SpanEssential>
          </UI.Typography>
          <UI.Input disabled value={email} size="medium" />
        </FormSection>
        <FormSection
          css={css`
            margin-top: 24px;
          `}
        >
          <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
            사용자 이름
            <SpanEssential>*</SpanEssential>
          </UI.Typography>
          <UI.Input size="medium" placeholder="사용자 이름" onChange={setName} />
        </FormSection>
        <AgreeContainer>
          <div
            css={css`
              display: flex;
              gap: 4px;
            `}
          >
            <UI.CheckBox size="medium" onChange={setAcceptPrivacy} selected={acceptPrivacy} />
            <UI.Typography
              style={{ textDecoration: "underline", cursor: "pointer" }}
              type="label01"
              fontStyle="medium"
              color="var(--alias-color-label-neutral)"
            >
              <p onClick={() => window.open("https://policy.mile.im/privacy/2024.10.25.html")}>
                개인정보 수집 및 이용 동의<SpanEssential>(필수)</SpanEssential>
              </p>
            </UI.Typography>
          </div>
          <div
            css={css`
              display: flex;
              gap: 4px;
            `}
          >
            <UI.CheckBox size="medium" onChange={setAcceptTerm} selected={acceptTerm} />
            <UI.Typography
              style={{ textDecoration: "underline", cursor: "pointer" }}
              type="label01"
              fontStyle="medium"
              color="var(--alias-color-label-neutral)"
            >
              <p onClick={() => window.open("https://policy.mile.im/service-agree/2024.11.01.html")}>
                이용약관 동의<SpanEssential>(필수)</SpanEssential>
              </p>
            </UI.Typography>
          </div>
        </AgreeContainer>
      </InputForm>
      <UI.Button
        disabled={!availableBtn()}
        primary
        size="large"
        title="구글 계정으로 회원가입"
        onClick={onHandleSignup}
      />
    </Container>
  );
};

export default GoogleSignup;
